module.exports = __webpack_public_path__ + "static/fonts/SCDream1.646cc08.woff";